var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "link text-theme flex items-center space-x-1",
      on: {
        click: function ($event) {
          return _vm.openSiteCart()
        },
      },
    },
    [
      _c("span", { staticClass: "w-5 h-5" }, [_c("CartMenuIcon")], 1),
      _vm._v(" "),
      !_vm.isLoading && _vm.cart
        ? _c(
            "span",
            { staticClass: "font-bold", attrs: { "data-testid": "cart-qty" } },
            [_vm._v(_vm._s(_vm.cart.totalQty))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Cart")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }